var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgDepartmentLogo02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 47,
    viewBox: "0 0 88 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1281_15427)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7227 15.7922H10.8084C13.0052 13.1219 15.309 12.2173 18.3237 12.2173C24.1775 12.2173 25.9247 15.9662 25.0768 21.3938L22.9485 35.0455H15.2319L16.9106 24.2772C17.2403 22.1679 18.1567 18.4625 14.3369 18.4625C11.1981 18.4625 9.93907 20.8328 9.51085 23.5857L7.72516 35.0411H0L3.4472 12.9479H11.1681L10.7227 15.7922Z",
    fill: "#004785"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9853 4.46721C40.6084 6.87659 38.3517 8.85976 35.9751 8.85976C33.5984 8.85976 31.9583 6.88094 32.3351 4.46721C32.712 2.05348 34.973 0.0703125 37.3454 0.0703125C39.7177 0.0703125 41.3621 2.04913 40.9853 4.46721Z",
    fill: "#D71920"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7986 35.0453H28.082L31.5292 12.9478H39.2458L35.8029 35.0453H35.7986Z",
    fill: "#004785"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5838 46.0702H38.8672L44.0144 12.9478H51.7353L46.5881 46.0702H46.5838Z",
    fill: "#004785"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5525 35.0453H76.8359L80.2831 12.9478H88.004L84.5568 35.0453H84.5525Z",
    fill: "#004785"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3947 12.1694C71.1959 12.1694 68.0742 13.5089 65.629 15.6617C65.629 15.6617 61.942 18.6017 60.9785 23.7162C60.9614 23.8032 60.9442 23.8858 60.9314 23.9728C60.9185 24.0598 60.91 24.1467 60.8971 24.2337C60.3619 26.8127 57.9167 28.8916 55.3474 28.8916C52.778 28.8916 50.8553 26.6735 51.2749 23.9771C51.6946 21.2807 54.2254 19.0627 56.8804 19.0627C58.2721 19.0627 59.4369 19.6759 60.1691 20.6458C61.3596 17.297 63.6592 15.2007 64.5028 14.5179C62.7942 13.0523 60.5331 12.1781 57.951 12.1781C51.5704 12.1781 45.5025 17.5014 44.4919 23.9771C43.4813 30.4572 47.892 35.7805 54.2725 35.7805C57.4713 35.7805 60.5888 34.4453 63.0383 32.2925C66.8537 29.2569 67.6973 24.1859 67.6973 24.1859C67.7102 24.1206 67.723 24.0511 67.7359 23.9815C67.7444 23.9162 67.753 23.851 67.7616 23.7858C68.2754 21.1807 70.7334 19.0714 73.3242 19.0714C75.9149 19.0714 77.8205 21.2894 77.3966 23.9858C76.9769 26.6822 74.4504 28.9003 71.7911 28.9003C70.3994 28.9003 69.2389 28.287 68.5024 27.3216C68.0784 28.5567 66.8751 31.3531 64.173 33.4494C65.8817 34.915 68.1341 35.7848 70.7163 35.7848C77.0968 35.7848 83.1648 30.4616 84.1754 23.9815C85.186 17.5057 80.7753 12.1825 74.3947 12.1825V12.1694Z",
    fill: "url(#paint0_linear_1281_15427)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1281_15427",
    x1: 45.3226,
    y1: 22.2288,
    x2: 83.9237,
    y2: 25.6576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#004785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#007DC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#004785"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1281_15427"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 46,
    fill: "white",
    transform: "translate(0 0.0703125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgDepartmentLogo02);
export default __webpack_public_path__ + "static/media/img-department-logo-02.01286b7a9a5c33bde2035f7c3df9e1f3.svg";
export { ForwardRef as ReactComponent };